import { updateField } from 'vuex-map-fields';
import * as MutationTypes from './mutation-types';
import { assignValue, resetValue } from './helpers';

const mutations = {
  [MutationTypes.SET_COURSES]: assignValue('courses'),
  [MutationTypes.RESET_COURSE]: resetValue('course'),
  [MutationTypes.SET_SPORTS]: assignValue('sports'),
  [MutationTypes.SET_CAMPUSES]: assignValue('campuses'),
  [MutationTypes.SET_COURSE]: assignValue('course'),
  [MutationTypes.SET_SUBSCRIPTION_LOADING]: assignValue('subscriptionLoading'),
  [MutationTypes.SET_PENDING_SUBSCRIPTION]: assignValue('pendingSubscription'),
  [MutationTypes.RESET_PENDING_SUBSCRIPTION]: resetValue('pendingSubscription'),
  [MutationTypes.SET_SUBSCRIPTIONS]: assignValue('subscriptions'),
  [MutationTypes.SET_SUBSCRIPTION]: assignValue('subscription'),
  [MutationTypes.SET_CURRENT_STUDENT]: assignValue('currentStudent'),
  [MutationTypes.SET_ALERT]: assignValue('alert'),
  [MutationTypes.SET_PROGRAMS]: assignValue('programs'),
  [MutationTypes.SET_SUBSCRIPTIONS_FILTER]: assignValue('subscriptionsFilter'),
  [MutationTypes.SET_COURSES_FILTER](state, { filter, value }) {
    state.filters[filter] = value;
  },
  [MutationTypes.SET_SETTINGS]: assignValue('settings'),
  [MutationTypes.SET_SIGN_UP_FORM]: assignValue('signUp'),
  updateField,
};

export default mutations;
